/**
 * EDIT THIRD PARTY REDUX ACTIONS
 *
 * @version 0.1
 */

import xhr from './../../utils/xhr';

const api = {
    get: (filters = { language: null, feedId: null }, sorting = { sortBy: "_id", direction: "DESC" }, pagination = { pageSize: -1, pageNumber: -1 }) => {
        let searchFilter = filters.language !== null ? `&language=${filters.language}` : ""
        return xhr.get({
            url: `/api/feeds/${filters.feedId}/articles/paginated?refreshFlag=true&pageNumber=${pagination.pageNumber}&pageSize=${pagination.pageSize}&sortBy=${sorting.sortBy}&direction=${sorting.direction}${searchFilter}`
        });
    },

    count: (filters = { language: null, feedId: null }) => {
        let searchFilter = filters.language !== null ? `?language=${filters.language}` : ""
        return xhr.get({
            url: `/api/feeds/${filters.feedId}/articles/count/${searchFilter}`
        });
    },
    loadFeedArticles: (feed, params) => {
        return xhr.get({
            url: '/api/feeds/'+feed+"/articles/paginated",
            data: params
        }).then((response) => {
            for (let i=0 ; i<response.body.length; i++) {
                response.body[i].index = i;
            }
            return response.body;
        })
    },

    loadFeedArticlesCount: (feed, params) => {
        return xhr.get({
            url: '/api/feeds/'+feed+"/articles/count",
            data: params
        }).then((response) => {
            return response.body;
        })
    },

    loadSingleArticle(articleId) {
        return xhr.get({
            url: '/api/entities/preview-article/' + articleId
        }).then((response) => {
            return response.body;
        });
    },

    getFeedInfo(feedId) {
        return xhr.get({
            url: '/api/feeds/' + feedId
        }).then((response) => {
            return response.body;
        });
    }

};


export default api;


// WEBPACK FOOTER //
// ./src/scripts/pages/ViewFeedContent/ViewFeedContent.api.js